<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import BuyNowButton from "../../../editor/nodes/BuyNowButton.vue";

export default BuyNowButton.extend({
  name: "BuyNowButtonV3",
  mixins: [FirebaseNodeV3],
})
</script>
